import {
  CustomEditor,
  TTableCellElement,
} from 'core-components/library/richTextEditor/interface/custom-types'

import { getCol, getGridTable, getStartCell, TableCol } from './commonTableHelper'

export const getInsertPositionCol = (editor: CustomEditor) => {
  const { gridTable } = getGridTable(editor)
  const startCell = getStartCell(editor)
  if (!startCell) {
    return
  }
  const startCellElement = startCell[0] as TTableCellElement
  const [insertPositionCol] = getCol(
    gridTable,
    (c: TableCol) => c.cell.key === startCellElement.key && c.isReal
  )
  return insertPositionCol
}
